(() => {
  'use strict';

  const root = document.querySelector(
    '[data-dg-lab-tool="mouse-accuracy"]'
  );

  if (!root) return;

  if (root.dataset.dgLabMouseAccuracyInitialized === 'true') return;
  root.dataset.dgLabMouseAccuracyInitialized = 'true';

  const stage = root.querySelector('#stage');
  const template = root.querySelector('#accuracyTargetTemplate');

  const restartButton = root.querySelector('#accuracyRestart');
  const finalPanel = root.querySelector('#accuracyFinal');

  if (
    !stage ||
    !template ||
    !restartButton ||
    !finalPanel
  ) {
    return;
  }

  const TOTAL_TARGETS = 30;

  /*
   * Estados:
   *
   * idle     → todavía no ha comenzado
   * running  → ronda activa
   * finished → ronda terminada
   */
  let state = 'idle';

  let hits = 0;
  let misses = 0;
  let score = 0;
  let targetsDone = 0;

  let startTime = 0;
  let finishTime = 0;

  let target = null;
  let timer = 0;

  function get(id) {
    return root.querySelector('#' + id);
  }

  /* =========================================================
     TIMER
     ========================================================= */

  function stopTimer() {
    if (timer) {
      clearInterval(timer);
    }

    timer = 0;
  }

  function startTimer() {
    if (timer) return;

    timer = window.setInterval(
      updateStats,
      100
    );
  }

  function getElapsedMilliseconds() {
    if (!startTime) return 0;

    if (
      state === 'finished' &&
      finishTime
    ) {
      return finishTime - startTime;
    }

    return performance.now() - startTime;
  }

  function formatSeconds(
    milliseconds,
    digits = 1
  ) {
    return (
      milliseconds / 1000
    ).toLocaleString(
      'es-ES',
      {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }
    );
  }

  /* =========================================================
     ESTADÍSTICAS
     ========================================================= */

  function updateStats() {
    const totalClicks =
      hits + misses;

    const accuracy =
      totalClicks > 0
        ? (hits / totalClicks) * 100
        : 100;

    const hitsElement = get('hits');
    const missesElement = get('miss');
    const accuracyElement = get('acc');
    const scoreElement = get('score');
    const targetsElement = get('targetsDone');
    const timeElement = get('time');

    if (hitsElement) {
      hitsElement.textContent = hits;
    }

    if (missesElement) {
      missesElement.textContent = misses;
    }

    if (accuracyElement) {
      accuracyElement.textContent =
        Math.round(accuracy);
    }

    if (scoreElement) {
      scoreElement.textContent = score;
    }

    if (targetsElement) {
      targetsElement.textContent =
        targetsDone;
    }

    if (timeElement) {
      timeElement.textContent =
        formatSeconds(
          getElapsedMilliseconds(),
          1
        );
    }
  }

  /* =========================================================
     INICIO
     ========================================================= */

  function ensureStarted() {
    if (state !== 'idle') return;

    state = 'running';

    startTime = performance.now();
    finishTime = 0;

    startTimer();

    const help = get('accuracyHelp');

    if (help) {
      help.textContent =
        'Completa los 30 objetivos con la mayor precisión posible.';
    }
  }

  /* =========================================================
     EFECTOS DEL IMPACTO
     ========================================================= */

  function createHitMarker(x, y) {
    const marker =
      document.createElement('span');

    marker.className =
      'accuracy-hit-marker';

    marker.style.left =
      x + 'px';

    marker.style.top =
      y + 'px';

    stage.appendChild(marker);

    window.setTimeout(
      () => {
        marker.remove();
      },
      320
    );
  }

  function createScorePopup(
    x,
    y,
    points,
    isMiss = false
  ) {
    const popup =
      document.createElement('span');

    popup.className =
      'accuracy-popup' +
      (isMiss ? ' is-miss' : '');

    popup.style.left =
      x + 'px';

    popup.style.top =
      y + 'px';

    popup.textContent =
      isMiss
        ? 'FALLO'
        : '+' + points;

    stage.appendChild(popup);

    window.setTimeout(
      () => {
        popup.remove();
      },
      560
    );
  }

  /* =========================================================
     PUNTUACIÓN POR DISTANCIA
     ========================================================= */

  function getPointsForImpact(
    event,
    targetElement
  ) {
    const rect =
      targetElement.getBoundingClientRect();

    const centerX =
      rect.left +
      rect.width / 2;

    const centerY =
      rect.top +
      rect.height / 2;

    const dx =
      event.clientX - centerX;

    const dy =
      event.clientY - centerY;

    const distance =
      Math.sqrt(
        dx * dx +
        dy * dy
      );

    /*
     * SVG:
     *
     * rojo             r = 10
     * oscuro interior  r = 24
     * azul interior    r = 42
     * blanco           r = 60
     * azul exterior    r = 78
     * oscuro exterior  r = 96
     *
     * IMPORTANTE:
     *
     * El oscuro exterior NO es una sexta zona.
     * Se considera borde decorativo.
     *
     * Por tanto:
     *
     * 0–10  = 100
     * 10–24 = 90
     * 24–42 = 80
     * 42–60 = 65
     * 60–78 = 50
     * >78   = fallo
     */

    const visualRadius =
      rect.width / 2;

    /*
     * El radio completo del SVG visible
     * corresponde a r=96.
     */
    const svgDistance =
      (distance / visualRadius) * 96;

    if (svgDistance <= 10) {
      return 100;
    }

    if (svgDistance <= 24) {
      return 90;
    }

    if (svgDistance <= 42) {
      return 80;
    }

    if (svgDistance <= 60) {
      return 65;
    }

    if (svgDistance <= 78) {
      return 50;
    }

    return 0;
  }

  /* =========================================================
     POSICIONAMIENTO
     ========================================================= */

  function getSafePosition(
    targetWidth,
    targetHeight
  ) {
    const padding = 14;

    const minCenterX =
      padding +
      targetWidth / 2;

    const maxCenterX =
      stage.clientWidth -
      padding -
      targetWidth / 2;

    const minCenterY =
      padding +
      targetHeight / 2;

    const maxCenterY =
      stage.clientHeight -
      padding -
      targetHeight / 2;

    const x =
      maxCenterX > minCenterX
        ? minCenterX +
          Math.random() *
          (maxCenterX - minCenterX)
        : stage.clientWidth / 2;

    const y =
      maxCenterY > minCenterY
        ? minCenterY +
          Math.random() *
          (maxCenterY - minCenterY)
        : stage.clientHeight / 2;

    return {
      x,
      y
    };
  }

  function spawn() {
    if (state === 'finished') return;

    if (target) {
      target.remove();
      target = null;
    }

    const fragment =
      template.content.cloneNode(true);

    const newTarget =
      fragment.querySelector(
        '.accuracy-target'
      );

    if (!newTarget) return;

    stage.appendChild(fragment);

    target =
      stage.querySelector(
        '.accuracy-target'
      );

    if (!target) return;

    const rect =
      target.getBoundingClientRect();

    const position =
      getSafePosition(
        rect.width,
        rect.height
      );

    target.style.left =
      position.x + 'px';

    target.style.top =
      position.y + 'px';

    target.addEventListener(
      'click',
      handleTargetClick
    );
  }

  /* =========================================================
     FINAL DE LA RONDA
     ========================================================= */

  function finishGame() {
    if (state === 'finished') return;

    state = 'finished';

    finishTime =
      performance.now();

    stopTimer();

    if (target) {
      target.remove();
      target = null;
    }

    updateStats();

    const elapsed =
      finishTime - startTime;

    const totalClicks =
      hits + misses;

    const accuracy =
      totalClicks > 0
        ? (hits / totalClicks) * 100
        : 0;

    const average =
      targetsDone > 0
        ? elapsed / targetsDone
        : 0;

    const finalScore =
      get('finalScore');

    const finalAccuracy =
      get('finalAccuracy');

    const finalTime =
      get('finalTime');

    const finalAverage =
      get('finalAverage');

    if (finalScore) {
      finalScore.textContent =
        score.toLocaleString('es-ES') +
        ' pts';
    }

    if (finalAccuracy) {
      finalAccuracy.textContent =
        Math.round(accuracy) +
        ' %';
    }

    if (finalTime) {
      finalTime.textContent =
        formatSeconds(
          elapsed,
          1
        ) +
        ' s';
    }

    if (finalAverage) {
      finalAverage.textContent =
        formatSeconds(
          average,
          2
        ) +
        ' s';
    }

    finalPanel.hidden = false;

    const help =
      get('accuracyHelp');

    if (help) {
      help.textContent =
        'Ronda finalizada · revisa tu resultado o repite la prueba.';
    }
  }

  /* =========================================================
     CLIC SOBRE LA DIANA
     ========================================================= */

  function handleTargetClick(event) {
    event.stopPropagation();

    if (state === 'finished') {
      return;
    }

    ensureStarted();

    const currentTarget =
      event.currentTarget;

    const points =
      getPointsForImpact(
        event,
        currentTarget
      );

    const stageRect =
      stage.getBoundingClientRect();

    const x =
      event.clientX -
      stageRect.left;

    const y =
      event.clientY -
      stageRect.top;

    createHitMarker(x, y);

    /*
     * Borde oscuro exterior:
     * visualmente pertenece a la diana,
     * pero NO es una zona válida.
     */
    if (points === 0) {
      misses += 1;

      createScorePopup(
        x,
        y,
        0,
        true
      );

      updateStats();

      /*
       * Un fallo NO cambia de objetivo.
       */
      return;
    }

    hits += 1;
    targetsDone += 1;
    score += points;

    createScorePopup(
      x,
      y,
      points
    );

    updateStats();

    /*
     * El objetivo número 30
     * termina la ronda.
     */
    if (
      targetsDone >=
      TOTAL_TARGETS
    ) {
      finishGame();
      return;
    }

    spawn();
  }

  /* =========================================================
     CLIC FUERA DE LA DIANA
     ========================================================= */

  stage.addEventListener(
    'click',
    (event) => {
      if (state === 'finished') {
        return;
      }

      if (
        event.target.closest(
          '.accuracy-target'
        )
      ) {
        return;
      }

      /*
       * Antes del primer impacto válido
       * no penalizamos clics fuera.
       */
      if (state === 'idle') {
        return;
      }

      misses += 1;

      const rect =
        stage.getBoundingClientRect();

      const x =
        event.clientX -
        rect.left;

      const y =
        event.clientY -
        rect.top;

      createHitMarker(x, y);

      createScorePopup(
        x,
        y,
        0,
        true
      );

      updateStats();
    }
  );

  /* =========================================================
     REINICIAR
     ========================================================= */

  function restartGame() {
    stopTimer();

    state = 'idle';

    hits = 0;
    misses = 0;
    score = 0;
    targetsDone = 0;

    startTime = 0;
    finishTime = 0;

    if (target) {
      target.remove();
      target = null;
    }

    /*
     * Limpiamos indicadores temporales
     * que pudieran quedar en pantalla.
     */
    stage
      .querySelectorAll(
        '.accuracy-hit-marker, .accuracy-popup'
      )
      .forEach((element) => {
        element.remove();
      });

    finalPanel.hidden = true;

    const help =
      get('accuracyHelp');

    if (help) {
      help.textContent =
        'Haz clic sobre la diana para comenzar.';
    }

    updateStats();
    spawn();
  }

  restartButton.addEventListener(
    'click',
    restartGame
  );

  /* =========================================================
     VISIBILIDAD
     ========================================================= */

  document.addEventListener(
    'visibilitychange',
    () => {
      if (document.hidden) {
        stopTimer();

        return;
      }

      if (state === 'running') {
        startTimer();
      }
    }
  );

  window.addEventListener(
    'resize',
    () => {
      if (
        target &&
        state !== 'finished'
      ) {
        spawn();
      }
    }
  );

  window.addEventListener(
    'pagehide',
    stopTimer,
    {
      once: true
    }
  );

  /* =========================================================
     ESTADO INICIAL
     ========================================================= */

  updateStats();
  spawn();
})();